export function attachPropertiesToComponent(component, properties) {
    const ret = component;
    for (const key in properties) {
        if (Object.prototype.hasOwnProperty.call(properties, key)) {
            ret[key] = properties[key];
        }
    }
    return ret;
}
